import React from 'react'
import { Router } from '@reach/router'
import Bookster from './Bookster'

export default function BooksterRoutes() {
  return (
    <Router>
      <Bookster path="/" />
    </Router>
  )
}
